export default Object.freeze({
  fri: 'Fri',
  mon: 'Mon',
  sat: 'Sat',
  sun: 'Sun',
  thu: 'Thu',
  tue: 'Tue',
  wed: 'Wed',
});
